var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItProfessional(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 77,
    viewBox: "0 0 88 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #6283a3;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #294b6e;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #0096d2;\r\n        font-size: 12px;\r\n        font-family: Lato-Medium, Lato;\r\n        font-weight: 500;\r\n        letter-spacing: 0.03em;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IT_Professionals",
    "data-name": "IT Professionals",
    transform: "translate(-2642 -123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_598",
    "data-name": "Group 598",
    transform: "translate(2660.113 123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    className: "cls-1",
    d: "M10,0H42A10,10,0,0,1,52,10v6a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    transform: "translate(-0.113 8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    className: "cls-2",
    d: "M5,0H22a5,5,0,0,1,5,5v6a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5A5,5,0,0,1,5,0Z",
    transform: "translate(12.887 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    className: "cls-3",
    width: 12,
    height: 3,
    transform: "translate(19.887 5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    className: "cls-2",
    d: "M0,0H52a0,0,0,0,1,0,0V17A10,10,0,0,1,42,27H10A10,10,0,0,1,0,17V0A0,0,0,0,1,0,0Z",
    transform: "translate(-0.113 22)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IT_Professionals-2",
    "data-name": "IT Professionals",
    className: "cls-4",
    transform: "translate(2686 197)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -43.986,
    y: 0
  }, "IT Professionals")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItProfessional);
export default __webpack_public_path__ + "static/media/ItProfessional.aa7172e557d948e9a6d979d51f413d53.svg";
export { ForwardRef as ReactComponent };